import { useEffect, useState } from "react"
import { useApi } from "../../../../../../utils"
import { ListCustomerImport } from "../../types"

interface FilteredParams {
  page?: number
  keyword?: string
  limit?: number
  file_name?: string
  file_status?: number
}

export function useList({ page, keyword, limit, file_name, file_status }: FilteredParams) {
  const defaultValue = {
    payload: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0
    }
  }

  const api = useApi()
  const [data, setData] = useState<ListCustomerImport>(defaultValue)
  const [isLoading, setLoading] = useState(true)


  const params: { [key: string]: number | string | undefined } = {};
  if (page) params.page = page;
  if (keyword) params.keyword = keyword;
  if (limit) params.limit = limit;
  if (file_name) params.file_name = file_name;
  if (file_status) params.file_status = file_status;

  const fetchUrl = () => api.get("/import-customer/list-file", { params })

  const fetchData = () => {
    setLoading(true)

    fetchUrl().then((res) => {
      setData(res.data)
    }).catch(() => {
      setData(defaultValue)
    }).finally(() => {
      setLoading(false)
    })
  }

  const refetch = () => fetchData()

   useEffect(() => {
    fetchData()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [page, keyword, limit, file_name, file_status])

  return { data, isLoading, refetch }
}